export default __webpack_public_path__ + "static/media/espn.ebec7742.svg";